'use client';

import { useEffect, useState } from 'react';

import { useCustomSearchParams } from '@lamesarv-sdk/hooks';

import { Modal } from '../Modal/Modal';

const getHashSanitized = (hash?: string) => {
  if (!hash || hash?.trim() === '#') return undefined;
  return hash.replaceAll('#', '').trim().toLowerCase();
};

const removeHash = () => {
  if (typeof window === 'undefined') return;
  if ('replaceState' in window.history) {
    window.history.replaceState('', window.document.title, window.location.pathname + window.location.search);
  }
};

// --

export interface IGenericHtmlModalProps {
  content: string;
  modal?: boolean;
  modal_url_parameter?: string;
  modal_hash_parameter?: string;
  class?: string; // Legacy support
  classes?: string;
}

export const GenericHtmlModal = (props: IGenericHtmlModalProps) => {
  const { searchParams } = useCustomSearchParams();
  const [modalOpen, setModalOpen] = useState(false);

  const hashParameter = getHashSanitized(props?.modal_hash_parameter);

  const onHashChanged = () => {
    if (typeof window !== 'undefined') {
      const hashLocation = getHashSanitized(window?.location?.hash);

      if (hashParameter) {
        setModalOpen(hashLocation === hashParameter);
      }
    }
  };

  const onClose = () => {
    setModalOpen(false);
    if (hashParameter) {
      removeHash();
    }
  };

  useEffect(() => {
    let modalOpenStatus: boolean = !!props.modal;

    if (props.modal && props.modal_url_parameter) {
      if (!!searchParams.get(props.modal_url_parameter)) {
        modalOpenStatus = true;
      } else {
        modalOpenStatus = false;
      }
    }

    if (typeof window !== 'undefined') {
      const hashLocation = getHashSanitized(window?.location?.hash);
      const hashParameter = getHashSanitized(props?.modal_hash_parameter);

      if (props.modal && !!hashParameter) {
        if (hashLocation === hashParameter) {
          modalOpenStatus = true;
        } else {
          modalOpenStatus = false;
        }
      }
    }

    setModalOpen(modalOpenStatus);

    // Hash Change Control
    if (typeof window !== 'undefined') {
      window.addEventListener('hashchange', onHashChanged);
      return () => {
        window.removeEventListener('hashchange', onHashChanged);
      };
    }
  }, []);

  if (props.modal) {
    return (
      <Modal isOpen={modalOpen} onClose={onClose} useMaxWidth={false}>
        <div dangerouslySetInnerHTML={{ __html: props.content }} className={props.class ?? props.classes} />
      </Modal>
    );
  }

  return <div dangerouslySetInnerHTML={{ __html: props.content }} className={props.class ?? props.classes} />;
};
